if (!customElements.get('top-nav')) {
  customElements.define(
    'top-nav',
    class TopNav extends window.BAO.CustomElement {
      CLASSES = {
        showNavigation: 'pg-TopNav_Inner-showNav',
      }

      constructor () {
        super()

        this.checkIfScrollable = this.checkIfScrollable.bind(this)
        this.checkIfScrollable()

        window.addEventListener('resize', this.checkIfScrollable)
      }

      setupListeners () {
        super.setupListeners()

        this.scrollLeft = this.scrollLeft.bind(this)
        this.scrollRight = this.scrollRight.bind(this)

        if (this.els?.left?.exists) {
          this.els.left.elements.forEach(leftEl => {
            this.listeners.add(leftEl, 'click', this.scrollLeft)
          })
        }

        if (this.els?.right?.exists) {
          this.els.right.elements.forEach(rightEl => {
            this.listeners.add(rightEl, 'click', this.scrollRight)
          })
        }
      }

      scrollLeft () {
        if (this.els?.scroller?.exists) {
          this.els.scroller.elements.forEach(scrollerEl => {
            scrollerEl.scrollLeft -= 100
          })
        }
      }

      scrollRight () {
        if (this.els?.scroller?.exists) {
          this.els.scroller.elements.forEach(scrollerEl => {
            scrollerEl.scrollLeft += 100
          })
        }
      }

      checkIfScrollable () {
        if (this.els?.scroller?.exists) {
          this.els.scroller.elements.forEach(scrollerEl => {
            this.classList.toggle(
              this.CLASSES.showNavigation,
              this.isScrollable(scrollerEl),
            )
          })
        }
      }

      isScrollable (element) {
        return (
          element.scrollWidth > element.clientWidth ||
          element.scrollHeight > element.clientHeight
        )
      }
    },
  )
}
